import React, { memo } from 'react';
import { SortableElement, SortEnd } from 'react-sortable-hoc';
import { CardTitle, Button } from 'reactstrap';
import { ProjectChecklistStepResponse } from '@business/entities/project';
import { SortableList } from '@modules/common/Sortable';
import { ProjectChecklistId, ProjectChecklistSectionResponse } from '@business/entities/project';
import { openAddEditChecklistSection } from './AddEditChecklistSectionModal';
import { openAddEditChecklistStep } from './AddEditChecklistStepModal';
import { SortableChecklistStepItem } from './CheckListStepItem';
import { TableActions } from '@modules/common/TableActions';

export interface ChecklistSectionItemProps {
  steps: ProjectChecklistStepResponse[];
  checklistId: ProjectChecklistId;
  onDelete(id: number): void;
  onStepDelete(id: number): void;
  section: ProjectChecklistSectionResponse;
  onStepSortEnd: (sectionId: number, sort: SortEnd) => void;
}

export const CheckListSectionItem = memo((props: ChecklistSectionItemProps) => {
  const { section, checklistId, onDelete, onStepSortEnd, steps, onStepDelete } = props;

  return (
    <div className="template-section border-bottom pb-2 mb-2">
      <CardTitle className="d-flex align-items-center justify-content-between">
        <div className="py-2 flex-fill">
          <span className="title mr-3">{section.name}</span>
          <Button
            color="light"
            className="waves-effect text-primary"
            onClick={() => openAddEditChecklistStep({ checklistId, sectionId: section.id })}
          >
            Add Step
          </Button>
        </div>
        <TableActions onDelete={() => onDelete(section.id)} onEdit={() => openAddEditChecklistSection({ checklistId, section: section })} />,
      </CardTitle>
      <SortableList lockAxis="y" distance={2} onSortEnd={sort => onStepSortEnd(section.id, sort)}>
        {steps.map((step, stepIndex) => (
          <SortableChecklistStepItem index={stepIndex} key={stepIndex} onDelete={onStepDelete} step={step} checklistId={checklistId} />
        ))}
      </SortableList>
    </div>
  );
});

export const SortableChecklistSectionItem = SortableElement(CheckListSectionItem);
